export default {"src":"/evde-internet/_next/static/media/Magic.a8eb5abb.svg","height":21,"width":20};